import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "react-datepicker/dist/react-datepicker.css";
import reportWebVitals from "./reportWebVitals";
import ThemeContextProvider from "./contexts/ThemeContext";
import AuthContextProvider from "./contexts/AuthContext";
import ConfiguratorContextProvider from "./contexts/ConfiguratorContext";
import GlobalStyles from "./shared/components/styled/GlobalStyles";
import App from "./App";
import { CognitoProvider } from "./shared/auth/cognito-react";
import { CognitoAuthClient } from "./shared/auth/cognito-browser";
import MissingTenantNotice from "./shared/components/MissingTenantNotice";
import {
  bootstrapAuth,
  getCognitoConfig,
  InvalidTenantUrlError,
} from "./shared/config/runtime-auth";

const container = document.getElementById("root");
const root = createRoot(container);

const renderBootstrapError = (error) => {
  const isInvalidTenant = error instanceof InvalidTenantUrlError;
  const message =
    error instanceof Error ? error.message : String(error);

  root.render(
    <div
      style={{
        fontFamily: "system-ui, sans-serif",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      {isInvalidTenant ? (
        <MissingTenantNotice />
      ) : (
        <div style={{ maxWidth: 520, lineHeight: 1.5 }}>
          <h1 style={{ fontSize: "1.25rem", marginTop: 0 }}>
            Unable to start the portal
          </h1>
          <p>{message}</p>
        </div>
      )}
    </div>,
  );
};

const renderApp = (cognitoInstance) => {
  root.render(
    <React.StrictMode>
      <CognitoProvider instance={cognitoInstance}>
        <ThemeContextProvider>
          <AuthContextProvider>
            <ConfiguratorContextProvider>
              <GlobalStyles />
              <App />
            </ConfiguratorContextProvider>
          </AuthContextProvider>
        </ThemeContextProvider>
      </CognitoProvider>
    </React.StrictMode>,
  );
};

void bootstrapAuth()
  .then(() => {
    const cognitoInstance = new CognitoAuthClient(getCognitoConfig());
    renderApp(cognitoInstance);
  })
  .catch(renderBootstrapError);

reportWebVitals();
